module.exports = require("./ru-KG.js");